module.exports = { "default": require("core-js/library/fn/json/stringify"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/_babel-runtime@5.8.38@babel-runtime/core-js/json/stringify.js
// module id = 113
// module chunks = 0